import { createUuid } from "./ids";

export function createIdempotencyKey(): string {
  return createUuid();
}
